import * as React from 'react';

interface IStatus {
  loading: boolean;
  error?: Error;
}

export interface IUserContext {
  status: IStatus;
  sub: string;
  company: {
    id: string;
    name: string;
  };
  email_verified: string;
  given_name: string;
  family_name: string;
  email: string;
  username: string;
  companyName: string;
  userpoolID: string;
  role: string;
}

const UserContext = React.createContext<IUserContext>({
  status: {
    loading: true,
    error: undefined,
  },
  company: { id: '', name: '' },
  sub: '',
  email_verified: '',
  given_name: '',
  family_name: '',
  email: '',
  username: '',
  companyName: '',
  userpoolID: '',
  role: '',
});

export { UserContext };
